import { useEffect, useState } from "react";
import { GetTodayPunchTime } from "../AttendanceApis";

const formatTime = (raw) => {
    if (!raw) return "—";
    const timePart = String(raw).split(".")[0];
    const [hStr, mStr] = timePart.split(":");
    if (hStr === undefined || mStr === undefined) return raw;
    const h = parseInt(hStr, 10);
    const m = mStr.padStart(2, "0");
    const period = h >= 12 ? "PM" : "AM";
    const h12 = h % 12 === 0 ? 12 : h % 12;
    return `${String(h12).padStart(2, "0")}:${m} ${period}`;
};

const AttendancePunchHistoryTable = ({
    row,
    subThStyle,
    subTdStyle,
    onHistoryLoaded,
}) => {
    const [punches, setPunches] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchPunches = async () => {
            if (!row?.employeeId) {
                setPunches([]);
                onHistoryLoaded?.(row, []);
                return;
            }

            setLoading(true);
            try {
                const response = await GetTodayPunchTime(row.employeeId);
                const history = response?.data ?? [];
                setPunches(history);
                onHistoryLoaded?.(row, history);
            } catch (error) {
                console.error("Punch fetch error:", error);
                setPunches([]);
                onHistoryLoaded?.(row, []);
            } finally {
                setLoading(false);
            }
        };

        fetchPunches();
    }, [row]);

    if (loading) {
        return (
            <span style={{ fontSize: "12px", color: "#6b7280" }}>
                Loading punch records...
            </span>
        );
    }

    if (!punches.length) {
        return (
            <span style={{ fontSize: "12px", color: "#9ca3af" }}>
                No punch records found.
            </span>
        );
    }

    return (
        <div style={{ overflowX: "auto" }}>
            <table
                style={{
                    width: "100%",
                    maxWidth: 900,
                    borderCollapse: "collapse",
                    textAlign: "center",
                    fontSize: "13px",
                }}
            >
                <thead>
                    <tr>
                        <th style={subThStyle}>S.No</th>
                        <th style={subThStyle}>Emp Code</th>
                        <th style={subThStyle}>Punch Time</th>
                    </tr>
                </thead>
                <tbody>
                    {punches.map((punch, index) => (
                        <tr key={`${punch.empCode ?? "punch"}-${index}`}>
                            <td style={subTdStyle}>{punch.sNo ?? index + 1}</td>
                            <td style={subTdStyle}>{punch.empCode ?? "—"}</td>
                            <td style={subTdStyle}>{formatTime(punch.punchTime)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AttendancePunchHistoryTable;
